module.exports = __webpack_public_path__ + "static/gcek-f1a3068ef91d46ca6b6730e5a8dec2fa.png";